// extracted by mini-css-extract-plugin
export default {"cls1":"FFHT6Hon1D3nioO8ivNj","cls2":"D8roz8aRG4dPolUk77Rf FFHT6Hon1D3nioO8ivNj"};